module.exports = __webpack_public_path__ + "static/SpecifyPERSONAL-ExpBlack-dc00b824bb392d6b22439d6a3c3c2470.woff2";